<template>
	<div class="container" :class="expanded ? '' : 'not-expanded'">
		<div class="header" @click="toggle">
			<span>{{ header }}</span>
			<font-awesome-icon icon="fa-light fa-times" size="1x" />
		</div>
		<div class="content">
			<div>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});

const expanded = ref(false);

const toggle = () => {
	expanded.value = !expanded.value;
};
</script>

<style lang="scss" scoped>
.header,
.content {
	font-size: 16px;
	width: 100%;
}

.header {
	font-family: 'courier_newregular', MessinaSerif, serif;
	cursor: pointer;
	text-transform: uppercase;
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;

	&.active {
		border-color: #b33030;
	}
}

.container {
	display: inline-block;
	font-size: 0;
	vertical-align: top;
	text-align: left;
	margin: 0;
	width: 100%;
	border-bottom: 1px solid #000;
	padding: 15px 5px 15px 0;
	overflow: hidden;

	.content {
		border: none;
		background: none;
		padding: 30px 0 20px;
		transition: all 300ms ease-out;

		h3 {
			margin: 5px 0;
		}

		.button {
			margin: 10px 0;
		}

		ul,
		ol {
			padding: 0 0 0 20px;
		}

		:deep(p) {
			margin: 0 0 20px;
		}
	}

	svg {
		transform: none;
		transition: all 0.2s ease-in-out;
	}

	&.not-expanded {
		svg {
			transform: rotate(45deg);
		}

		.content {
			transform: scaleY(0);
			transform-origin: top;
			opacity: 0;
			height: 0;
			padding: 0 20px;
		}
	}
}
</style>
